import Handyman from "@mui/icons-material/Handyman";
import { Box, Tooltip } from "@mui/material";

import { PREVIEW_ICON_FONT_SIZE, type PreviewVariant, previewTooltipForVariant } from "./constants";

type PreviewFeatureIndicatorProps = {
  fontSize?: number | string;
  inline?: boolean;
  /** Nav context passes the same color as the adjacent nav icon. */
  color?: string;
  /** `newVersion` when an existing experience is still available behind the preview. */
  variant?: PreviewVariant;
};

export function PreviewFeatureIndicator({
  fontSize = PREVIEW_ICON_FONT_SIZE,
  inline = false,
  color = "text.secondary",
  variant = "gated",
}: PreviewFeatureIndicatorProps) {
  return (
    <Tooltip title={previewTooltipForVariant(variant)}>
      <Box
        component="span"
        sx={{
          display: inline ? "inline-flex" : "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          lineHeight: 0,
          cursor: "help",
        }}
      >
        <Handyman
          aria-label="In development for this organization"
          sx={{
            fontSize,
            color,
            display: "block",
          }}
        />
      </Box>
    </Tooltip>
  );
}
